import { render, staticRenderFns } from "./GroupMetricsPanel.vue?vue&type=template&id=c9fe24d6&scoped=true"
import script from "./GroupMetricsPanel.vue?vue&type=script&lang=js"
export * from "./GroupMetricsPanel.vue?vue&type=script&lang=js"
import style0 from "./GroupMetricsPanel.vue?vue&type=style&index=0&id=c9fe24d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fe24d6",
  null
  
)

export default component.exports